import { useContext, useEffect } from 'react';
import { pick, pipe } from 'ramda';
import { usePortletDispatch, usePortletSelector } from 'js/components/system/Portlet';
import { GamesFeaturesContext } from 'js/components/hocs/withGameFeatures';
import { filterByCategories, filterByEmptyGames, filterByFeatures, filterByVolatility } from './Filters/filters';
import { setFilteredCategoriesAction } from './actions';

export default (filtersEnabled) => {
    const dispatch = usePortletDispatch();
    const features = useContext(GamesFeaturesContext);
    const {
        categories,
        filters: { selectedCategories, selectedFeatures, selectedVolatility }
    } = usePortletSelector(pick([
        'categories',
        'filters'
    ]));

    // update groupedFilteredCategories on `categories` change when filters are disabled
    useEffect(() => {
        if (!filtersEnabled) {
            dispatch(setFilteredCategoriesAction(categories));
        }
    }, [filtersEnabled, categories, dispatch]);

    useEffect(() => {
        if (filtersEnabled) {
            const nextCategories = pipe(
                filterByCategories(selectedCategories),
                filterByFeatures(selectedFeatures, features),
                filterByVolatility(selectedVolatility, features),
                filterByEmptyGames
            )(categories);

            dispatch(setFilteredCategoriesAction(nextCategories));
        }
    }, [filtersEnabled, selectedCategories, selectedFeatures, selectedVolatility, categories, features, dispatch]);
};
